import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
// components
import ResetPasswordform from '../../components/Form/ResetPasswordform';
// API
import Api from '../../API';

const ResetPassword = () => {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const [disabled, setDisabled] = useState(false);

  const params = useParams();

  const sendResetPasswordRequset = async (password) => {
    const resetToken = params.resetToken;

    const response = await Api.resetPassword(resetToken, password);

    if (response.error) {
      if (response.error?.startsWith('Too many requests')) {
        setDisabled(true);
      }
      setError(response.error);
      setSuccess('');
    } else {
      setError('');
      setSuccess('Password reset successfully.');
    }
  };

  return (
    <Container className='pt-5'>
      {
        <Alert
          className='mt-5'
          variant={error ? 'danger' : 'success'}
          show={error || success}
        >
          {error || success}
          {success && (
            <Link to='/login' className='ms-3' replace={true}>
              Go to login
            </Link>
          )}
        </Alert>
      }
      <ResetPasswordform
        className='mt-5'
        callback={sendResetPasswordRequset}
        disabled={disabled}
      />
    </Container>
  );
};

export default ResetPassword;
